<template>
  <div class="pages d-flex a-center j-center">
	  <a href="" class="prev"></a>
	  <div class="num d-flex">
		  <a href="" class="active">1</a>
		  <a href="">2</a>
		  <a href="">3</a>
		  <a href="">4</a>
		  <a href="">5</a>
	  </div>
	  <a href="" class="next"></a>
	  <slot></slot>
  </div>
</template>

<script>

export default {
  data() {
    return {}
  }
}

</script>

<style lang="less">
	.pages{
		margin-top: .4rem;
		a{
			display: block;
			width: .4rem;
			height: .4rem;
			border-radius: 5px;
			background: #fff;
			margin: 0 .05rem;
			color: #666;
			text-align: center;
			line-height: .4rem;
			&:hover,&.active{
				background: #2657db;
				color: #fff;
			}
			&.next{
				background: #fff url(@/assets/Icons/next.png) no-repeat center/5px;
				&:hover{
					background: #2657db url(@/assets/Icons/nextWhite.png) no-repeat center/5px;
				}
			}
			&.prev{
				background: #fff url(@/assets/Icons/prev.png) no-repeat center/5px;
				&:hover{
					background: #2657db url(@/assets/Icons/prevWhite.png) no-repeat center/5px;
				}
			}
		}
		
	}
</style>
